import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import {
  GermanPensionCalculatorResultDTO,
  IncomeEstimatesDTO,
  StatutoryEstimatesDTO,
} from '../dto/pension-calculator.dto.types';
import { GermanCalculatorResult } from '../model/german-calculator';
import {
  IncomeEstimatesResult,
  PensionCalculatorResult,
  StatutoryEstimatesResult,
} from '../model/pension-calculator';

export class PensionCalculatorMapper extends Mapper<GermanCalculatorResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    pensionCalculatorResultDTO: GermanPensionCalculatorResultDTO
  ): PensionCalculatorResult {
    return {
      status: pensionCalculatorResultDTO.Status,
      statutoryEstimates: this.createMapper(
        PensionCalculatorStatutoryEstimatesMapper
      ).toDomain(pensionCalculatorResultDTO.StatutoryEstimates),
      incomeEstimates: this.createMapper(
        PensionCalculatorIncomeEstimatesMapper
      ).toDomain(pensionCalculatorResultDTO.IncomeEstimates),
      incomeEstimationDate: pensionCalculatorResultDTO.IncomeEstimationDate,
      retirementDate: pensionCalculatorResultDTO.RetirementDate,
    };
  }
}

export class PensionCalculatorStatutoryEstimatesMapper extends Mapper<StatutoryEstimatesResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    statutoryEstimatesDTO: StatutoryEstimatesDTO
  ): StatutoryEstimatesResult {
    return {
      statutoryRetirementDate: statutoryEstimatesDTO.StatutoryRetirementDate,
      currentRate: statutoryEstimatesDTO.CurrentRate,
    };
  }
}

export class PensionCalculatorIncomeEstimatesMapper extends Mapper<IncomeEstimatesResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(incomeEstimatesResult: IncomeEstimatesDTO): IncomeEstimatesResult {
    return {
      onePercentRate: incomeEstimatesResult.OnePercentRate,
      twoPercentRate: incomeEstimatesResult.TwoPercentRate,
      currentRate: incomeEstimatesResult.CurrentRate,
    };
  }
}
